import {fork, take, put, select} from 'redux-saga/effects';
import {fetchRequest} from '@computerrock/formation-core';
import * as adminActionTypes from '../adminActionTypes';
import * as dashboardActionTypes from '../../dashboard/dashboardActionTypes';
import {TOKEN_ID} from '../../utils/saveAdminToken';

const adminAllowedSports = function* adminAllowedSports({payload}) {
    const {match, location} = payload;
    const {params, path} = match;
    const {serviceManager} = yield select(state => state.application);

    const id = localStorage.getItem(TOKEN_ID);

    if (!id) {
        yield put({
            type: adminActionTypes.SET_ERRORS,
            payload: {error: 'No authenticated user found'},
        });
        return;
    }

    const ftemStrapiService = serviceManager.loadService('ftemStrapiService');

    yield fork(
        fetchRequest,
        adminActionTypes.FETCH_SPORTS_REQUEST,
        ftemStrapiService.getAlowedSports,
        {userId: id},
    );

    const responseAction = yield take([
        adminActionTypes.FETCH_SPORTS_REQUEST_SUCCEEDED,
        adminActionTypes.FETCH_SPORTS_REQUEST_FAILED,
    ]);

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const sportDTOs = response;

        yield put({
            type: adminActionTypes.STORE_ADMIN_SPORTS,
            payload: {sportDTOs},
        });
    } else {
        yield put({
            type: adminActionTypes.SET_ERRORS,
            payload: {error: responseAction.payload.error.message},
        });
    }
};

export default adminAllowedSports;
